const mp3List: Array<{
  id: string;
  name: string;
  url: string;
  platform: string;
  type: string;
}> = [
  {
    id: "1007",
    name: "智娜",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/41d3c888d9ea4580a1e17d4e4e49ffd6.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "301032",
    name: "爱小荷",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/84f4343aabfa4bd586093eba915385db.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "301037",
    name: "爱小静",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/876413b866a242aabdbfdc6eb890c415.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "301004",
    name: "爱小玲",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/881f608b5b4e499fb3610fea3190a925.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "301030",
    name: "爱小溪",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/2c2ce55e0445411e88f12053c3cf6af5.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "101032",
    name: "智芳",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/d6d52ba43ecc4df8b720e841a0e6750e.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "101055",
    name: "智付",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/d7cb2ee95d04444ca03503b87ee63616.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "1002",
    name: "智聆",
    url:
      "https://oss.5kong.com/tts/mp3/2023/08/17/735d103783ce4ae19805ff1e9fc0d261.mp3",
    platform: "腾讯云",
    type: "中文场景"
  },
  {
    id: "aliyun_lydia",
    name: "Lydia",
    url:
      "https://oss.5kong.com/app/test/2024/04/08/bf6a5de6fc9c8ab15c190bced621d990.wav",
    platform: "阿里云",
    type: "英文以及英中文混合场景"
  },
  {
    id: "aliyun_aiyue",
    name: "艾悦",
    url:
      "https://oss.5kong.com/app/test/2024/04/08/cff081c620371204397a0acbad43e59c.wav",
    platform: "阿里云",
    type: "中文及中英文混合场景"
  },
  {
    id: "aliyun_aijing",
    name: "艾婧",
    url:
      "https://oss.5kong.com/app/test/2024/04/08/e7daa5fdb3671b830ce62acd89defea3.wav",

    platform: "阿里云",
    type: "中文及中英文混合场景"
  }
];

export default mp3List;
